 const config = {
     apiKey: "[apikey]",
     authDomain: "[projId].firebaseapp.com",
     databaseURL: "https://[projId].firebaseio.com",
     projectId: "[projId]",
     storageBucket: "[projId].appspot.com",
     messagingSenderId: "[messagingSenderId]",
     appId: "[appId]",
     measurementId: "[measurementId]",
};

export default config;
